<template>
    <section class="section general-list-block" 
             :class="{'general-list-blockTs': brandName === Brand.Travelsphere}">
        <div class="full-width">
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <ol class="card-list">
                            <li class="card-list__item no-opacity"
                                :key="item.id"
                                v-for="item in items">
                                <article class="card js-card">

                                    <div class="card__img-holder">

                                        <picture>
                                            <img class="card__img img-responsive lazyload" 
                                                :src="`${item.image.largeUrl}?format=webp`"
                                                :alt="item.image.altText"
                                                loading="lazy">
                                        </picture>

                                        <div v-if="item.tourSummary.offerText" class="offer-tag">{{ item.tourSummary.offerText }}</div>

                                    </div>

                                    <div class="card__content">

                                        <div class="card__inner">

                                            <div class="card__header">
                                                <h3 class="card__title">{{ item.name }}</h3>
                                            </div>

                                            <div class="card__description">
                                                <p v-html="item.description"></p>
                                            </div>

                                        </div>

                                        <div class="tour-price">

                                            <div class="tour-price__days"><strong>{{ item.tourSummary.fromDays }} days</strong> from</div>

                                            <div class="tour-price__value">{{ item.tourSummary.fromPriceFormatted }}</div>

                                            <div v-if="item.tourSummary.hasWasFromPrice" class="tour-price__was-value">was <strong>{{ item.tourSummary.wasPriceFormatted }}</strong></div>

                                        </div>

                                        <a :href="item.url" aria-label="Explore" class="btn card__btn">Explore</a>

                                    </div>

                                </article>
                            </li>
                        </ol>
                        <div class="cta-holder">

                            <button class="btn btn--alt"
                                    v-if="itemsRemaining > 0"
                                    @click="loadMore"
                                    :aria-label="loadMoreButtonText"
                                    :title="loadMoreButtonText">
                                {{loadMoreButtonText}}
                            </button>

                            <div class="pt-20"
                                 v-if="this.totalPages > 1">
                                <strong>{{ take > itemsCount ? itemsCount : take }}</strong>  of <strong>{{this.itemsCount}}</strong> tours
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import { mapState } from 'vuex';
import {Brand} from '../../brand.js';

export default {
    name: "ToursByPrice",
    props: ['thresholdPrice', 'brandName'],

    data() {
        return {
            Brand,
            loadMoreButtonText: 'Load More',
            loadMoreAmount: 12,
            startAmount: 12,
        };
    },

    computed: {
        ...mapState('toursByPrice', ['items', 'itemsRemaining', 'take', 'totalPages', 'itemsCount']),
    },

    methods: {
        // load more button clicked
        loadMore() {
            this.$store.commit('toursByPrice/setTake',this.take + this.loadMoreAmount);
            this.$store.dispatch('toursByPrice/fetchItems', this.thresholdPrice);
        },
    },

    created() {
        // set how many items we load
        this.$store.commit('toursByPrice/setTake', this.startAmount);
        this.$store.dispatch('toursByPrice/fetchItems', this.thresholdPrice);
    }
};
</script>
